/**
 * @module Root
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const environment = {
  production: true,
  hmr: false,
  channel: 'web',
  env: 'production',
};
